<!-- REGULAR NAV -->

<nav class="navbar navbar-expand-lg navbar-light fixed-top">
  <div>
    <a class="navbar-brand" href="javascript:void(0)">
      <img [routerLink]="['']" alt="" src="/assets/logo.png" />
    </a>

    <ng-container *ngIf="user; else loadingUser">
      <div class="menubtns">
        <ng-container *ngIf="!isClient(); else clientCorner">
          <button
            routerLinkActive="active"
            [routerLink]="['/projecten']"
            mat-flat-button
            class="btn-gray"
          >
            Projecten
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/immo']"
            mat-flat-button
            class="btn-gray"
          >
            Immo IP.
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/producten']"
            mat-flat-button
            class="btn-gray"
          >
            Producten
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/bedrijven']"
            mat-flat-button
            class="btn-gray"
          >
            Bedrijven
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/contacten']"
            mat-flat-button
            class="btn-gray"
          >
            Contacten
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/planning']"
            mat-flat-button
            class="btn-gray"
          >
            Planning
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/signs-portal']"
            mat-flat-button
            class="btn-gray"
          >
            Borden
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/zoek-jobs']"
            mat-flat-button
            class="btn-gray"
          >
            Zoek
          </button>
        </ng-container>

        <ng-template #clientCorner>
          <button
            routerLinkActive="active"
            [routerLink]="['/client-corner/home']"
            mat-flat-button
            class="btn-gray"
            [disabled]="
              selectedCompany != null && selectedCompany.pendingInvoices
            "
          >
            Home
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/client-corner/projecten']"
            mat-flat-button
            class="btn-gray"
            [disabled]="
              selectedCompany != null && selectedCompany.pendingInvoices
            "
          >
            Kaart
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/client-corner/lopende']"
            mat-flat-button
            class="btn-gray"
            [disabled]="
              selectedCompany != null && selectedCompany.pendingInvoices
            "
          >
            Lopende opdrachten
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/client-corner/uitgevoerde']"
            mat-flat-button
            class="btn-gray"
            [disabled]="
              selectedCompany != null && selectedCompany.pendingInvoices
            "
          >
            Uitgevoerde opdrachten
          </button>

          <button
            routerLinkActive="active"
            [routerLink]="['/client-corner/afgehaalde']"
            mat-flat-button
            class="btn-gray"
            [disabled]="
              selectedCompany != null && selectedCompany.pendingInvoices
            "
          >
            Weggehaalde opdrachten
          </button>
        </ng-template>

        <mat-divider vertical="true"></mat-divider>

        <tabs-component></tabs-component>
      </div>
    </ng-container>

    <ng-template #loadingUser>
      <mat-spinner
        style="margin: auto"
        color="primary"
        diameter="24"
      ></mat-spinner>
    </ng-template>
  </div>

  <div class="menubtns">
    <mat-divider vertical="true"></mat-divider>

    <div *ngIf="loadingService.showLoader" class="right-space">
      <mat-icon *ngIf="loadingService.saved" svgIcon="check"></mat-icon>

      <mat-icon *ngIf="loadingService.error" class="error-icon" color="primary">
        error
      </mat-icon>

      <mat-spinner
        *ngIf="loadingService.saving"
        color="primary"
        diameter="24"
      ></mat-spinner>
    </div>

    <div *ngIf="isTestEnvironment()" class="test-environment-text-align">
      <span class="test-environment-text">TESTOMGEVING</span>
    </div>

    <div *ngIf="isClient()" class="company-select-container">
      <mat-select
        matInput
        placeholder="Bedrijf"
        [(ngModel)]="selectedCompany"
        (ngModelChange)="onSelectedCompanyChange()"
        [compareWith]="compareCompanies"
      >
        <mat-option
          *ngFor="let company of selectableCompanies"
          [value]="company"
        >
          {{ company.name }}
        </mat-option>
      </mat-select>
    </div>

    <mat-form-field appearance="outline" class="right-space search">
      <input
        class="align-search-bar-content"
        type="number"
        matInput
        placeholder="Geef projectnummer in"
        (keydown)="keyPress($event)"
        [(ngModel)]="projectNumber"
      />

      <mat-icon
        matSuffix
        (click)="navigateToProject()"
        class="clickable align-search-bar-content"
      >
        search
      </mat-icon>
    </mat-form-field>

    <span *ngIf="this.user">
      <div
        class="user"
        [matMenuTriggerFor]="accountMenu"
        matTooltip="{{ user?.firstName }} {{ user?.lastName }}"
      >
        <div class="rounded-circle employee-initials">
          <span
            *ngIf="!this.user.profilePicture"
            class="employee-initials rounded-circle in-the-middle no-margin"
          >
            {{ getLettres() }}
          </span>

          <span
            *ngIf="this.user.profilePicture"
            class="in-the-middle rounded-circle"
          >
            <img
              class="rounded-circle"
              *ngIf="isImage(user.profilePicture)"
              width="30px"
              height="30px"
              src="/api/assets/{{ user.profilePicture.uuid }}"
            />
          </span>
        </div>
      </div>

      <mat-menu class="menu" #accountMenu="matMenu" yPosition="below">
        <button mat-menu-item (click)="profile()" *ngIf="isAdmin()">
          Profiel
        </button>

        <button mat-menu-item (click)="toPlacerView()" *ngIf="showToPlacerView">
          Naar installateursportaal
        </button>

        <button mat-menu-item (click)="users()" *ngIf="isAdmin()">
          Klanten
        </button>

        <button mat-menu-item (click)="employees()" *ngIf="isAdmin()">
          Werknemers
        </button>

        <button
          mat-menu-item
          (click)="stopImpersonate()"
          *ngIf="isImpersonating()"
        >
          Stop nabootsing
        </button>
        <button mat-menu-item (click)="clientPortalConfiguration()">
          Configuratie van klantportaal
        </button>
        <button mat-menu-item (click)="logout()">Log out</button>
      </mat-menu>
    </span>
  </div>
</nav>
